<template>
  <Navbar homeviewsubpage logourl="/rental/home" />

  <section id="orderInfo">
    <div class="container pt-5" data-aos="fade-up">
      <div class="section-caption">
        <h2 v-if="traditionalTransfer">Płatność przelewem - informacja</h2>
        <h2 v-if="dotPay">Płatność Przelewy24 - informacja</h2>
      </div>
      <div class="tile">
        <div class="section-content">
          <div v-if="orderSuccess">
            <Alert
              v-if="traditionalTransfer"
              alert-type="alert-success"
              alert-text="Zamówienie zostało złożone pomyślnie. Aby przedłużyć abonament wykonaj przelew zgodnie z danymi zawartymi w proformie wysłanej na podany w usłudze adres email."
            />
            <div v-if="dotPay" class="alert alert-success text-center">
              Zamówienie zostało złożone pomyślnie. W ciągu 5 sekund zostaniesz
              przekierowany do strony z płatnościami. Po udanej płatności
              abonament zostanie automatycznie przedłużony. <br />
              Jeśli nie nastąpiło automatyczne przekierowanie do strony z
              płatnościami - kliknij
              <a :href="dotPayPaymentLink" class="alert-link">tutaj</a>.
              <div v-if="this.paymentRequestResponseFailure">
                Nie udało się przekierować do sklepu!
              </div>
            </div>
            <Alert
              v-if="invoiceMailSendFailure"
              alert-type="alert-warning"
              alert-text="Nie udało się wysłać proformy na podany w usłudze adres email. Skontaktuj się z biurem obsługi klienta."
            />
          </div>
          <div v-else>
            <Alert
              alert-type="alert-danger"
              alert-text="Nie udało się złożyć zamówienia. Skontaktuj się z biurem obsługi klienta."
            />
          </div>
          <div class="text-center">
            <button class="btn-standard" @click="onMainPageButtonClick">
              Strona główna
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import { RequestResult } from "@/utils/requestResult";
import store from "@/store";
import { makeRequest, scrollToTop } from "@/utils/helpers";
import Alert from "@/components/Alert.vue";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "OrderInfoView",
  components: { Navbar, Footer, Alert },

  data() {
    return {
      orderId: null,
      orderSuccess: null,

      dotPay: null,
      traditionalTransfer: null,

      paymentRequestResponseFailure: null,
      invoiceMailSendFailure: null,

      dotPayPaymentLink: null,

      paymentTimeout: null
    };
  },

  created() {
    scrollToTop();

    this.orderSuccess = store.state.orderSuccess;
    this.orderId = store.state.orderId;

    this.dotPay = store.state.dotPay;
    this.traditionalTransfer = store.state.traditionalTransfer;

    store.commit("SetDotPayPaymentCounter", 1);
    let dotPayPaymentCounter = store.state.dotPayPaymentCounter;

    if (this.traditionalTransfer) this.sendInvoiceOnMail(this.orderId);
    else if (this.dotPay) {
      if (dotPayPaymentCounter === 1) {
        this.sendInvoiceAndSaveDotPayLink();

        this.paymentTimeout = setTimeout(() => {
          let link = document.createElement("a");
          link.href = this.dotPayPaymentLink;
          link.click();
        }, 5000);
      } else this.dotPayPaymentLink = store.state.dotPayPaymentLink;
    }
  },

  methods: {
    onMainPageButtonClick() {
      this.$router.push(this.routePath.Login);

      if (this.paymentTimeout != null && this.paymentTimeout > 0)
        window.clearTimeout(this.paymentTimeout);
    },

    async sendInvoiceOnMail(orderId) {
      this.invoiceMailSendFailure = false;

      let data = {
        action: this.request.SendInvoiceOnMail,
        orderid: orderId,
      };

      let invoiceOnMailResponse = await makeRequest(data);

      switch (invoiceOnMailResponse.data.error) {
        case RequestResult.OK: {
          // jest ok - idziemy dalej => przechodzimy do płatności lub kiedy normalny przelwe nic nie robimy
          break;
        }
        case RequestResult.GeneralError: {
          this.invoiceMailSendFailure = true;
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
      }
    },

    async sendInvoiceAndSaveDotPayLink() {
      this.paymentRequestResponseFailure = false;

      if (this.orderSuccess) {
        let data = {
          action: this.request.RentalSubscriptionPayment,
          extendSubAmount: store.state.orderAmount,
          orderid: store.state.orderId,
        };

        let rentalSubscriptionPaymentResponse = await makeRequest(data); // tu dostaję linka do którego przechodzę oraz aktualizuję payment_link i wysyłam proformę z linkiem do płatności na maila
        if (rentalSubscriptionPaymentResponse.data) {
          await this.sendInvoiceOnMail(this.orderId);
          this.dotPayPaymentLink = rentalSubscriptionPaymentResponse.data;
          store.commit(
            "SetDotPayPaymentLink",
            rentalSubscriptionPaymentResponse.data
          );
        } else this.paymentRequestResponseFailure = true;
      } else {
        // wracamy do glównej strony
        this.$router.push(this.routePath.Login);
      }
    },
  },
};
</script>

<style scoped></style>
